import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { MetadataLabelSettings } from '@/types/diagram';

interface MetadataSettingsTabProps {
    settings: MetadataLabelSettings;
    onChange: (key: keyof MetadataLabelSettings, value: number) => void;
}

export const MetadataSettingsTab: React.FC<MetadataSettingsTabProps> = ({
    settings,
    onChange
}) => {
    const handleAngleChange = (degrees: number) => {
        const radians = (degrees * Math.PI) / 180;
        onChange('smoothingAngle', radians);
    };

    const getCurrentAngleInDegrees = () => {
        return Math.round((settings.smoothingAngle * 180) / Math.PI);
    };

    return (
        <div className="space-y-4">
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Minimum X Spacing
                </Label>
                <Input
                    type="number"
                    value={settings.minSpacing}
                    onChange={(e) => onChange('minSpacing', parseInt(e.target.value))}
                    min={1}
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Minimum Y Spacing
                </Label>
                <Input
                    type="number"
                    value={settings.minYSpacing}
                    onChange={(e) => onChange('minYSpacing', parseInt(e.target.value))}
                    min={1}
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Smoothing Angle (degrees)
                </Label>
                <Input
                    type="number"
                    value={getCurrentAngleInDegrees()}
                    onChange={(e) => handleAngleChange(parseInt(e.target.value))}
                    min={0}
                    max={360}
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
            <div>
                <Label className="block text-sm font-medium text-white mb-1">
                    Step Size
                </Label>
                <Input
                    type="number"
                    value={settings.stepSize}
                    onChange={(e) => onChange('stepSize', parseInt(e.target.value))}
                    min={1}
                    className="bg-surface-input border-surface-border text-white"
                />
            </div>
        </div>
    );
};